import { useEffect } from "react";
import { LOGO_URL } from "@/data/constants";

const DEFAULT_DESC =
  "The world's most trusted source for wolfdog news, legislation, education, and community.";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  const id = "seo-jsonld";
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSeo({ title, description, image, type = "website", published, author, jsonLd } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Wolfdog News`
      : "Wolfdog News — Truth. Awareness. Protection.";
    document.title = fullTitle;
    const desc = description || DEFAULT_DESC;
    const url = typeof window !== "undefined" ? window.location.href : "";
    const img = image || LOGO_URL;

    setMeta("name", "description", desc);
    setMeta("name", "robots", "index, follow");

    // Open Graph
    setMeta("property", "og:site_name", "Wolfdog News");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    if (url) setMeta("property", "og:url", url);
    if (img) setMeta("property", "og:image", img);

    // Twitter Card
    setMeta("name", "twitter:card", img ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    if (img) setMeta("name", "twitter:image", img);

    // Article-specific
    if (type === "article" && published) setMeta("property", "article:published_time", published);
    if (type === "article" && author) setMeta("property", "article:author", author);

    if (url) setLink("canonical", url);

    setJsonLd(jsonLd || null);
  }, [title, description, image, type, published, author, jsonLd]);
}
